import React from "react";
import { Link } from "react-router-dom";
import { prefetchStory } from "./storyPrefetch";

export default function StoryCard({ story }) {
  const to = story.url_link?.substring(0,story.url_link.lastIndexOf('.html')) || '';
  return (
    <Link
      to={to}
      className="story-card"
      state={{ thumb: story.stimg }}
      onMouseEnter={() => prefetchStory(to)}
      onTouchStart={() => prefetchStory(to)}
    >
      <div className="story-card-ring">
        <div className="thumb">
          <img src={story.stimg} alt={story.title} loading="lazy" />
          <div className="thumb-scrim" />
          {story.pages && <span className="pages-badge">◧ {story.pages}</span>}
          <div className="meta">
            <div className="title">{story.title}</div>
            {story.pubdate && <div className="date">{story.pubdate}</div>}
          </div>
        </div>
      </div>
    </Link>
  );
}
